import { FC, useMemo, useState, createContext, SetStateAction, Dispatch } from 'react';

export type TabId = { tab?: string; panel?: string };

export type TabIds = { [name: string]: TabId };

type Props = { activeTab: string; setActiveTab: (activeTab: string) => void };

type ActiveTabContextType = {
    activeTab: string;
    setActiveTab: (activeTab: string) => void;
    selectedTab?: string;
    setSelectedTab: Dispatch<SetStateAction<string>>;
};
type TabIdsContext = {
    tabIds: TabIds;
    setTabIds: Dispatch<SetStateAction<TabIds>>;
};

export const ActiveTabContext = createContext<ActiveTabContextType | null>(null);
export const TabIdsContext = createContext<TabIdsContext | null>(null);

export const TabProvider: FC<Props> = ({ activeTab, setActiveTab, children }) => {
    // keep tabpanel/tab ids in array so each tabpanel and tab can link the index of
    // their partner. array is parallel to tabpanel/tablist order.
    const [tabIds, setTabIds] = useState<TabIds>({});

    const [selectedTab, setSelectedTab] = useState(activeTab);

    // memoize bc variables are bundled in objects
    // const tabsContext = useMemo(() => ({ setTabIds, tabIds }), [tabIds]);
    const tabsContext = { setTabIds, tabIds };
    const activeTabContext = useMemo(
        () => ({ selectedTab, setSelectedTab, activeTab, setActiveTab }),
        [activeTab, setActiveTab, selectedTab, setSelectedTab]
    );
    return (
        <TabIdsContext.Provider value={tabsContext}>
            <ActiveTabContext.Provider value={activeTabContext}>
                {children}
            </ActiveTabContext.Provider>
        </TabIdsContext.Provider>
    );
};
